'use strict';

angular.module('selfAccessRequestControllers')

.controller('AdHocSideBarSameAsController',
            ['$scope', '$state', '$stateParams', 'selfAccessRequest', 'selfAccessRequestService',
    function ($scope, $state, $stateParams, selfAccessRequest, selfAccessRequestService) {

        $scope.selfAccessRequest = selfAccessRequest;
        $scope.sameAsUserId = $stateParams.sameAsEmployeeID;

    }
]);